"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_ffe63475{background:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";padding:8px;pointer-events:none}.root_ffe63475.hasMediumDelay_ffe63475{-webkit-animation-delay:300ms;animation-delay:300ms}.content_ffe63475{font-size:12px;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";word-wrap:break-word;overflow-wrap:break-word}.subText_ffe63475{margin:0}\n" }]);
exports.root = "root_ffe63475";
exports.hasMediumDelay = "hasMediumDelay_ffe63475";
exports.content = "content_ffe63475";
exports.subText = "subText_ffe63475";
//# sourceMappingURL=Tooltip.scss.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Tooltip/Tooltip.scss.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Tooltip/Tooltip.scss.js
// module chunks = 1